module.exports = __webpack_public_path__ + "static/media/user-lock.320c6f69.svg";